import ImgVictor from "../../assets/images/about/Victor.svg";
import ImgPaul from "../../assets/images/about/Paul.svg";
import ImgLeslie from "../../assets/images/about/Leslie.svg";
import ImgKunal from "../../assets/images/about/Kunal.svg";
import ImgGeorge from "../../assets/images/about/George.svg";

export const TEAM_DATA = [
  {
    id: 0,
    name: "Victor Hugo Gomez",
    position: "Chief Executive Officer",
    shortPosition: "CEO",
    image: ImgVictor,
    twitter: "",
    linkedin: "",
    description:
      "A serial entrepreneur, Victor has accumulated many years of experience in Fintech (former Senior Vice President of Ventures for Deutsche Borse Group), as well as in the institutional investment space (Mercer Consulting).",
    direction: "left",
  },
  {
    id: 1,
    name: "Paul Herrera",
    position: "Chief Enterprise Architect",
    shortPosition: "CEA",
    image: ImgPaul,
    twitter: "",
    linkedin: "",
    description:
      "A technologist and quantitative finance passionate, Paul has years of relevant experience in the field (as VP of Data Analytics at Bitbull Capital, a SFO based Hedge Fund). He is also co-founder of Avanti Financial Services, a firm that develops IT infrastructure for institutional investors.",
    direction: "right",
  },
  {
    id: 2,
    name: "Leslie Nicholson",
    position: "Chief Product Officer",
    shortPosition: "CPO",
    image: ImgLeslie,
    twitter: "",
    linkedin: "",
    description:
      "An experienced product leader with over twenty years in the investment industry working for exchanges and data/analytics solutions providers. Previously Head of Indexes and ESG Data Products at TMX Group, Leslie’s scope encompassed TSX, TSX Venture Exchange and Bourse de Montréal. ",
    direction: "left",
  },
  {
    id: 3,
    name: "Kunal Dhawan",
    position: "Chief Technology Officer",
    shortPosition: "CTO",
    image: ImgKunal,
    twitter: "",
    linkedin: "",
    description:
      "A technology leader with a demonstrated history of working in the IT and service industries. Kunal has years of industry experience, most notably at Alberta TechWorks, SAS and Canadian Western Bank. A professional with a MBA focused in IT Architecture & Strategic Consulting from University of Alberta.",
    direction: "right",
  },
  {
    id: 4,
    name: "George Kuznetsov",
    position: "Chief Operating Officer",
    shortPosition: "COO",
    image: ImgGeorge,
    twitter: "",
    linkedin: "",
    description:
      "With formidable experience working at some of the most prestigious companies in the fields of Data and Analytics (Coalition Development), Financial Services (DWS, Allianz), and Strategic Consulting (Partner at McKinsey & Co), George has joined BITA as COO and member of the management team. His customer-first mindset will prove invaluable as the leader of our operations team.",
    direction: "left",
  },
];
